module.exports = __webpack_public_path__ + "img/team_leader_7.3ba1e74b.png";